import React from 'react'
import useSWRMutation from 'swr/mutation'

import { addConversationFeedback } from '../../../api/user-feedback'
import Loading from '../../components/layout/Loading'
import ErrorMessage from '../../components/errors/ErrorMessage'
import FeedbackForm from '../../components/user-feedback/FeedbackForm'
import { UserFeedback } from '../../../api/user-feedback/types'
import { useToaster } from '../../../libraries/toaster'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = { conversationId: number, msgIndex: number }
const AdvisorAiFeedback: React.FC<Props> = ({ conversationId, msgIndex }) => {
  const { showSuccess } = useToaster()
  const { t } = useI18N()

  const { trigger: triggerAddFeedback, isMutating, error: addFeedbackError } = useSWRMutation(
    `/conversation/${conversationId}/feedback`,
    addConversationFeedback,
    { onSuccess: () => { showSuccess(t('ai.user.feedback.saved')) } },
  )

  const handleSubmit = async(feedback: UserFeedback) => {
    await triggerAddFeedback({ conversationId, messageIndex: msgIndex, ...feedback })
  }

  if(isMutating) { return <Loading /> }
  if(addFeedbackError) { return <ErrorMessage message='Error adding Conversation feedback' /> }

  return <FeedbackForm onSubmit={handleSubmit} />
}

export default AdvisorAiFeedback
